import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalFormPropriedadePage } from './modal-form-propriedade.page';

const routes: Routes = [
  {
    path: '',
    component: ModalFormPropriedadePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalFormPropriedadePageRoutingModule {}
